export default __webpack_public_path__ + "static/media/20.9fb8c7ac.jpg";